import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { IAudioFileSetting } from 'entities/Settings/api/types'

export class DropsRow extends RowBase<IAudioFileSetting> {
  constructor(origin: IAudioFileSetting) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get url() {
    return this.origin.url
  }

  get duration() {
    return this.origin.duration
  }
}
